import React, {useEffect, useState} from "react";
import {APP_SECTION, duplicateObject, PAGES} from "../../../scripts/constants";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {Button, Col, Container, Modal, Row} from "react-bootstrap";
import {
  dtoForProduct,
  duplicateProduct,
  getAvailableProducts,
  productForDTO,
  productForId
} from "../../../scripts/product-manager";
import ProductCardSimpleAnnuity from "./ProductCardSimpleAnnuity";
import {isEqual, mygaSession} from "../../../scripts/myga-session";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  MM_CALCULATOR,
  MM_PRODUCT,
  MM_PRODUCT_DTO,
  MM_PRODUCT_ID,
  MM_PRODUCT_VISUALS
} from "../../../scripts/myga-model";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {saveApplication as syncApplication, saveApplication} from "../../../scripts/sync-manager";
import {CircleSwatch} from "react-color/lib/components/circle/CircleSwatch";
import {CirclePicker} from "react-color";
import {NassauLog} from "../../../scripts/myga-utils";
import {Analytics} from "../../../scripts/analytics";
import {PageManager} from "../../../scripts/page-manager";
import GENERATOR from "../../../selenium-front-end/generator/Generator";

const DISPLAY_MODE = Object.freeze({
  store: 'store',
  cart: 'cart'
});

class ProductStore extends React.Component {
  
  constructor(props) {
    super(props);
    // setup default prev/next pages with props overrides
    // this.prevPage = props.prevPage || PAGES.pageAppProcessOverview; // 2021.07.14.ADivelbiss - commented in favor of PageManager page stack solution
    // this.nextPage = props.nextPage || PAGES.pageAppFinances;  // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
  
    // make a deep-copy.
    const DTOs = JSON.parse(JSON.stringify(mygaSession.getCurrentAppProductDTOs()));
    
    // Get the current cart from the myga session
    let cart = DTOs.map(dto=>productForDTO(dto));

    // get the unfiltered products from the product manager
    let products = getAvailableProducts();
  
    this.state = {
      mode: cart.length>0?DISPLAY_MODE.cart:DISPLAY_MODE.store,
      cart: cart,
      products: products,
      toCustomize: null,
      errorMessage : ''
    }
  }
  
  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
    
    // check that at least one item was added to the cart.
    if (this.isCartEmpty()) {
      this.setState({
        errorMessage: 'Please add at least one product to your cart to continue.'
      });
      return false;
    }
  
    // check that the user modified all products in the cart
    else if (!this.didUserModifyProductsInCart()) {
      this.setState({
        errorMessage: 'Please select your premium amount for each product.'
      });
      return false;
    }
    return true;
  };

  onNextPressed = async () => {
    
    // 2022.05.31.ADivelbiss - Updated to support the new product DTO structure
    // 2022.06.08.ADivelbiss - Save after this step then we'll have both the previous and next states available
    // without extra work
    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
  
      // Start the action list
      const actionList = [];
  
      const initProductDTOs = [...mygaSession.getCurrentAppProductDTOs()];
      const nextProductDTOs = this.state.cart.map(p=>dtoForProduct(p));
      
      // check for any changes
      if (!isEqual(initProductDTOs,nextProductDTOs)) {
        NassauLog('products changed');
  
        // Check for any current products and remove them
        initProductDTOs.forEach((dto)=> {
          actionList.push({
            type: 'click',
            id: `btnRemove_${dto[MM_PRODUCT_DTO.productID]}`
          });
        });
  
        // add back the new products
        nextProductDTOs.forEach((dto)=>{
          actionList.push({
            type: 'click',
            id: `btnAdd_${dto[MM_PRODUCT_DTO.productID]}`
          });
          actionList.push({
            type: 'keys',
            value: `${dto[MM_PRODUCT_DTO.premium]}`,
            id: 'product-premium-amount',
            stagedId: `product-premium-amount_${dto[MM_PRODUCT_DTO.productID]}`
          });
          actionList.push({
            type: 'sleep',
            value: 500,
            stagedId: `sleep_${dto[MM_PRODUCT_DTO.productID]}`
          });
          actionList.push({
            type: 'click',
            id: 'successBtn',
            stagedId: `successBtn_${dto[MM_PRODUCT_DTO.productID]}`
          });
          // TODO: If there is more than one product we need to go back and add it. but the UI currently supports only one.
        });
  
        await GENERATOR.stageManualActionList(actionList);
      }
    }

    // save the application data.
    await this.saveApplication()
  
  }
  
  saveApplication = async () => {
  
    const nextProductDTOs = this.state.cart.map(p=>dtoForProduct(p));

    // 2022.05.24.ADivelbiss - apply all existing parties to all products at present.
    const nextParties = [...mygaSession.getCurrentAppParties()];
    nextProductDTOs.forEach(dto=>dto[MM_PRODUCT_DTO.parties]=nextParties);
  
    // 2022.05.24.ADivelbiss - apply all existing benes to all products at present.
    const nextBenes = [...mygaSession.getCurrentAppBenes()];
    nextProductDTOs.forEach(dto=>dto[MM_PRODUCT_DTO.benes]=nextBenes);

    // Save the cart data
    mygaSession.setCurrentAppProductDTOs(nextProductDTOs)
    
    // Save to the backend
    await saveApplication(APP_SECTION.products)
  };
  
  cartCount() {
    return this.state.cart.length;
  }
  
  isCartEmpty() {
    return this.cartCount()===0;
  }
  
  getProductFromCart = (pid) => {
    if (this.state.cart.length>0) {
      let index = this.state.cart.findIndex(p=>(p[MM_PRODUCT.productID]===pid));
      if (index>=0) {
        return this.state.cart[index];
      }
    }
    return null;
  };
  
  cartIndex(product, cart = this.state.cart) {
    return (product!==null) && cart.findIndex(p=>(p[MM_PRODUCT.productID]===product[MM_PRODUCT.productID]));
  }
  
  isInCart(product) {
    return this.cartIndex(product)>=0;
  }
  
  addToCart(product) {
    const pid = product[MM_PRODUCT.productID];
    const index = this.cartIndex(product);
    let nextCart = [...this.state.cart];
    if (index>=0) {
      nextCart[index] = product;
    } else {
      nextCart.push(duplicateProduct(product));
    }
    this.setState({
      cart: nextCart,
      mode: DISPLAY_MODE.cart,
      errorMessage: ''
    },()=>{
      Analytics.fireProductAddToCart([product]);
    });
  }
  
  removeFromCart(product) {
    let nextCart = [...this.state.cart];
    let pid = product[MM_PRODUCT.productID];
    NassauLog(`removeFromCart: ${pid}`);
    const index = this.cartIndex(product);
    NassauLog(`removeFromCart: ${pid} index: ${index}`);
    if (index>=0) {
      nextCart.splice(index, 1);
      this.setState({
        mode: nextCart.length>0? DISPLAY_MODE.cart : DISPLAY_MODE.store,
        cart: nextCart,
        errorMessage: ''
      },()=>{
        Analytics.fireProductRemoveFromCart([product]);
      });
    }
  }
  
  didUserModifyProductsInCart = () => {
    return this.state.cart.reduce((result,product)=>{
      return result && product[MM_PRODUCT.userModified];
    },true)
  }
  
  availableProducts = () => {
    return this.state.products.filter(prod=>!this.isInCart(prod));
  };
  
  renderStore() {
    let products = (this.state.mode===DISPLAY_MODE.store) ?
        this.availableProducts() :
        this.state.cart;
    // NassauLog(`products: ${JSON.stringify(products,null,2)}`);
    // TODO: add filtering
    return (
        <Container className={'product-list pb-0'}>
          {
            products.length>0 ? (
                <div className={''}>
                  {
                    products.map((product,index)=>{
                      return (
                          <Row id={product[MM_PRODUCT.productID]} key={index} className={index<products.length-1 ? 'product-row pt-4' : 'pt-4'}>
                            {/* product card */}
                            <Col className={'col-md-12 col-lg-8 pb-4 '}>
                              <ProductCardSimpleAnnuity key={index}
                                                        product={product}
                                                        editing={false}
                                                        onClick={(e)=>{
                                                          this.setState({toCustomize: duplicateProduct(product)},()=>{
                                                            Analytics.fireProductSelected([product]);
                                                          })
                                                        }}/>
                            </Col>
                            {/* product buttons */}
                            <Col className={'col-md-12 col-lg-4 text-center pb-4 pl-0 pr-0'}>
                              <Row>
                                <Col className={'col-lg-12 pb-2 pl-1 pr-1'}>
                                  <Button id={`btn${this.isInCart(product)?'Remove':'Add'}_${product[MM_PRODUCT.productID]}`}
                                          variant={this.isInCart(product)?'danger':'success'}
                                          className={'product-cart-button'}
                                          onClick={(e)=>{
                                            e.preventDefault();
                                            if (this.isInCart(product)) {
                                              this.removeFromCart(product);
                                            } else {
                                              this.setState({toCustomize: duplicateProduct(product)},()=>{
                                                Analytics.fireProductSelected([product]);
                                              })
                                              // this.addToCart(product)
                                            }
                                          }} >
                                    {
                                      this.isInCart(product) ?
                                          (<>Change selection</>) :
                                          (<>SELECT</>)
                                      // this.isInCart(product) ?
                                      //     (<>Remove from Cart</>) :
                                      //     (<>Add to Cart</>)
                                    }
                                  </Button>
                                </Col>
                                {/* Commented Customize button in case it is needed again*/}
                                {/*<Col className={'col-lg-12 pb-2 pl-1 pr-1'}>*/}
                                {/*  <Button variant={'secondary'}*/}
                                {/*          className={'product-cart-button'}*/}
                                {/*          onClick={(e)=>{*/}
                                {/*            this.setState({toCustomize: duplicateProduct(product)})*/}
                                {/*          }}>*/}
                                {/*    Customize*/}
                                {/*  </Button>*/}
                                {/*</Col>*/}
                              </Row>
                            </Col>
                          </Row>
                      )
                    })
                  }
                </div>
            ) : this.renderProductListEmpty()
          }
        </Container>
    );
  }
  
  renderProductListEmpty() {
    return (
        <Row>
          <Col className={'text-center'}>
            {
              this.state.mode===DISPLAY_MODE.cart ?
                  this.renderCartEmptyMessage() :
                  this.renderNoProductMessage()
            }
          </Col>
        </Row>
    )
  }
  
  renderNoProductMessage() {
    return (
        <>
          <p>There are no more products available</p>.
          {
            this.cartCount()>0 && (
                <div>
                  <Button variant={'primary'}
                          className={'product-continue-shopping-button'}
                          onClick={e => {
                            e.preventDefault();
                            this.setState({
                              mode: DISPLAY_MODE.cart
                            })
                          }}>
                    View your cart?&nbsp;&nbsp;
                    <FontAwesomeIcon icon={'shopping-cart'}
                                     color={'white'}
                                     size={'lg'}/>
                  </Button>
                </div>
            )
          }
        </>
    )
  }
  
  renderCartEmptyMessage() {
    return (
        <>
          <p>Your cart is currently empty.</p>
          <div>
            <Button variant={'primary'}
                    className={'product-continue-shopping-button'}
                    onClick={e => {
                      e.preventDefault();
                      this.setState({
                        mode: DISPLAY_MODE.store
                      })
                    }}>
              Continue shopping?&nbsp;&nbsp;
              <FontAwesomeIcon icon={'store'}
                               color={'white'}
                               size={'lg'}/>
            </Button>
          </div>
        </>
    )
  }
  
  saveCustomProduct = (product) => {
    this.addToCart(product);
    this.hideCustomizeModal();
  };
  hideCustomizeModal = () => this.setState({toCustomize:null, modalErrorMessage:''});
  
  render() {
    return (
        <AppContentWrapper
            onBackPressed={this.saveApplication}
            onNextPressed={this.onNextPressed}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>
  
          <Container>
            <Row>
              <Col>
                {
                  (this.state.mode===DISPLAY_MODE.store) ? (
                      <div className={'product-list-header dark'}><FontAwesomeIcon icon={'store'}/>&nbsp;Available Products: {this.availableProducts().length}</div>
                  ) : (
                      <div className={'product-list-header dark'}><FontAwesomeIcon icon={'shopping-cart'}/>&nbsp;Your Selected Product</div>
                      // <div className={'product-list-header'}><FontAwesomeIcon icon={'shopping-cart'}/>&nbsp;Items in your cart: {this.state.cart.length}</div>
                  )
                }
              </Col>
              {/*<Col className={'col-auto text-right'}>*/}
              {/*  {*/}
              {/*    (this.state.mode===DISPLAY_MODE.store) ? (*/}
              {/*        <div>*/}
              {/*          {*/}
              {/*            this.cartCount()>0 && (*/}
              {/*                <>{this.cartCount()} </>*/}
              {/*            )*/}
              {/*          }*/}
              {/*          <FontAwesomeIcon icon={'shopping-cart'}*/}
              {/*                           color={this.isCartEmpty()?'#aaaaaa88':'#426DA0F5'}*/}
              {/*                           onClick={e => {*/}
              {/*                             e.preventDefault();*/}
              {/*                             this.setState({*/}
              {/*                               mode: DISPLAY_MODE.cart*/}
              {/*                             })*/}
              {/*                           }}*/}
              {/*                           size={'lg'}/>*/}
              {/*        </div>*/}
              {/*    ) : (*/}
              {/*        <div onClick={e => {*/}
              {/*          e.preventDefault();*/}
              {/*          this.setState({*/}
              {/*            mode: DISPLAY_MODE.store*/}
              {/*          })*/}
              {/*        }}>*/}
              {/*          <FontAwesomeIcon icon={'chevron-left'}*/}
              {/*                           color={'#426DA0F5'}*/}
              {/*                           size={'lg'}/>&nbsp;&nbsp;*/}
              {/*          {*/}
              {/*            this.availableProducts().length>0 && (*/}
              {/*                <>{this.availableProducts().length} </>*/}
              {/*            )*/}
              {/*          }*/}
              {/*          <FontAwesomeIcon icon={'store'}*/}
              {/*                           color={'#426DA0F5'}*/}
              {/*                           size={'lg'}/>*/}
              {/*        </div>*/}
              {/*    )*/}
              {/*  }*/}
              {/*</Col>*/}
            </Row>
          </Container>
          <Container className="page-section pb-0">
            {this.renderStore()}
          </Container>
          {
            this.state.toCustomize && (
                <CustomProductModal product={this.state.toCustomize}
                                    onSave={this.saveCustomProduct}
                                    onCancel={this.hideCustomizeModal}
                                    saveButtonText={this.isInCart(this.state.toCustomize)?"Save":"Add to Cart"} />
            )
          }
        </AppContentWrapper>
    );
  }
  
}

function CustomProductModal(props) {

  // assert: props.products exists
  let product = props.product;
  let show = (product!==null && product!==undefined);
  
  const premiumMin = product[MM_PRODUCT.calculator][MM_CALCULATOR.premiumMin];
  const initPremium = Math.max(premiumMin,product[MM_PRODUCT.calculator][MM_CALCULATOR.premium]);
  const initCardColor = product[MM_PRODUCT.visuals][MM_PRODUCT_VISUALS.cardColor];
  
  let [premium, setPremium] = useState(initPremium);
  let [cardColor, setCardColor] = useState(initCardColor);
  let [errorMessage, setErrorMessage] = useState('');
  
  useEffect(()=>{
    setErrorMessage('');
  },[premium])
  
  let isUserModified = product => product[MM_PRODUCT.userModified];
  
  const saveButtonText = props.saveButtonText || "Save";
  const onCancel = () => {
    if (props.onCancel) {
      props.onCancel();
    }
  };
  
  const onSave = () => {
    if (!isUserModified(product)) {
      setErrorMessage('Please select your premium amount');
      return;
    }
    let premiumMin = product[MM_PRODUCT.calculator][MM_CALCULATOR.premiumMin];
    let premiumMax = product[MM_PRODUCT.calculator][MM_CALCULATOR.premiumMax];
    if (premium<premiumMin) {
      setErrorMessage('The premium amount is too low.');
    } else if (premium>premiumMax) {
      setErrorMessage('The premium amount is too high.');
    } else if (props.onSave) {
      product[MM_PRODUCT.visuals][MM_PRODUCT_VISUALS.cardColor] = cardColor;
      product[MM_PRODUCT.calculator][MM_CALCULATOR.premium] = premium;
      props.onSave(product);
    }
  };
  
  return (
      <Modal
          size={'lg'}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={props.onCancel}
      >
        {/*<Modal.Header closeButton>*/}
        {/*  <Modal.Title>Customizing</Modal.Title>*/}
        {/*</Modal.Header>*/}
        <Modal.Body className="pb-4 pl-xs-0 pr-xs-0 pl-sm-1 pr-sm-1">
          <Container className={'pl-0 pr-0'}>
            <Row className={'pl-0 pr-0 text-center'}>
              <Col className={'pl-0 pr-0 pl-sm-2 pr-sm-1'}>
                {
                  show && (<ProductCardSimpleAnnuity product={product}
                                                     cardColor={cardColor}
                                                     editing={true}
                                                     onPremiumChange={setPremium}/>)
                }
              </Col>
              {/*<Col className={'col-lg-auto pt-3 pl-2 pr-2 p-sm-4 text-center'}>*/}
              {/*  <div className={'product-color-selector-container'}>*/}
              {/*    <CirclePicker*/}
              {/*        onChangeComplete={(color,e)=>{*/}
              {/*          // NassauLog(`color: ${JSON.stringify(color)}`);*/}
              {/*          setCardColor(color.hex);*/}
              {/*        }}/>*/}
              {/*  </div>*/}
              {/*  <div className={'p-3'}>*/}
              {/*    <Button variant={'outline-danger'} onClick={()=>{*/}
              {/*      setCardColor(product[MM_PRODUCT.visuals][MM_PRODUCT_VISUALS.cardColorDefault]);*/}
              {/*    }}>*/}
              {/*      Reset</Button>*/}
              {/*  </div>*/}
              {/*</Col>*/}
            </Row>
            {
              errorMessage && errorMessage.length>0 && (
                  <Row className={'text-center'}>
                    <Col sm={3} className="hidden-xs" />
                    <Col xs={12} sm={6} >
                      <div className="validation-error" style={{textAlign: "center"}}>
                        {errorMessage}
                      </div>
                    </Col>
                  </Row>
              )
            }
          </Container>
        </Modal.Body>
        <Modal.Footer style={{justifyContent: 'space-between', flexWrap: 'nowrap'}}>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button id={'successBtn'} variant="success" onClick={onSave}>
            {saveButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
  )
}

export default ProductStore;